export { unstable_batchedUpdates } from "react-dom";
//# sourceMappingURL=reactBatchedUpdates.js.map